/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import Chart from 'react-apexcharts'
import {
  IDadosGraficosPesquisaModel,
  IGraficoDispersaoDimensaoModel,
  IGraficoDispersaoTipoModel,
} from '../helpers/AnaliseResultadoHelper'

type Props = {
  showModal: boolean
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  dimensaoIndex: number | undefined
  dispersaoIndex: number | undefined
  fillColor: string | undefined
  dadosGraficosPesquisa: IDadosGraficosPesquisaModel | undefined
}

const ModalGraficoDispersao = ({
  showModal,
  setShowModal,
  dimensaoIndex,
  dispersaoIndex,
  fillColor,
  dadosGraficosPesquisa,
}: Props) => {
  const [dimensao, setDimensao] = useState<IGraficoDispersaoDimensaoModel>()
  const [dispersao, setDispersao] = useState<IGraficoDispersaoTipoModel>()
  const [percentuaisPerguntas, setPercentuaisPerguntas] = useState<Record<number, string>>({})
  const [graficoAberto, setGraficoAberto] = useState<{ perguntaId: number; titulo: string } | null>(null)

  useEffect(() => {
    if (!dadosGraficosPesquisa) return
    if (dimensaoIndex == null || dispersaoIndex == null) return

    const idsFinalizados = new Set(dadosGraficosPesquisa.Participantes.map(p => p.Id))
    const dim = dadosGraficosPesquisa.GraficoDispersao.Dimensoes[dimensaoIndex]
    const disp = dim.Dispersoes[dispersaoIndex]
    setDimensao(dim)
    setDispersao(disp)

    const mapa = new Map<number, number>()
    let soma = 0
    disp.Perguntas.forEach(q => {
      const respondentes = new Set(q.IdsParticipantes.filter(i => idsFinalizados.has(i)))
      mapa.set(q.Id, respondentes.size)
      soma += respondentes.size
    })
    const pt: Record<number, string> = {}
    mapa.forEach((v, k) => {
      pt[k] = soma > 0 ? ((v / soma) * 100).toFixed(2) : '0.00'
    })
    setPercentuaisPerguntas(pt)
  }, [dadosGraficosPesquisa, dimensaoIndex, dispersaoIndex])

  const valorDispersaoSelecionada =
    dadosGraficosPesquisa?.GraficoDispersao.Series.find(s => s.tipo === dispersao?.Tipo)
      ?.data?.[dimensaoIndex ?? 0] ?? 0

  const getDadosGraficoPergunta = (qid: number) => {
    const disp = dimensao?.Dispersoes ?? []
    const labels: string[] = []
    const valores: number[] = []
    let total = 0
    disp.forEach(d => {
      const q = d.Perguntas.find(p => p.Id === qid)
      const qtd = q?.IdsParticipantes.length ?? 0
      labels.push(d.Nome)
      total += qtd
      valores.push(qtd)
    })
    const porcentagens = valores.map(cnt => (total > 0 ? Number(((cnt / total) * 100).toFixed(2)) : 0))
    return { labels, porcentagens, total }
  }

  return (
    <>
      <div className={`modal ${showModal ? 'show' : ''} fade`} tabIndex={-1} style={{ display: showModal ? 'block' : 'none' }} id='kt_modal_1'>
        <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl'>
          <div className='modal-content border border-1' style={{ borderColor: fillColor + ' !important' }}>
            <div className='modal-header d-flex align-items-center' style={{ backgroundColor: fillColor }}>
              <h3 className='modal-title mb-0'>{`${dispersao?.Nome ?? ''}: ${dimensao?.Nome ?? ''}`}</h3>
              <div className='d-flex align-items-center gap-2 ms-auto'>
                <span className='badge-value'>
                  {`${valorDispersaoSelecionada.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`}
                </span>
              </div>
              <div onClick={() => setShowModal(false)} className='btn btn-icon btn-sm btn-active-light-primary ms-2'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
              </div>
            </div>
            <div className='modal-body'>
              {dispersao?.Perguntas.map((p, pi) => {
                const perc = percentuaisPerguntas[p.Id] || '0.00'
                return (
                  <div key={p.Id} className={`w-100 ${pi < (dispersao.Perguntas.length - 1) ? 'mb-8' : ''}`}>
                    <div className='card card-custom border border-secondary border-1 shadow-sm'>
                      <div className='card-header d-flex justify-content-between align-items-center' style={{ backgroundColor: 'rgba(218,218,217,1)' }}>
                        <h5 className='mb-0'>{p.Texto}</h5>
                        <div className='d-flex align-items-center gap-2'>
                          <span className='badge-value'>
                            {`${Number(perc).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`}
                          </span>
                          <button className='btn btn-icon btn-sm btn-light' onClick={() => setGraficoAberto({ perguntaId: p.Id, titulo: p.Texto })}>
                            <KTSVG path='/media/icons/duotune/graphs/gra001.svg' className='svg-icon svg-icon-2x' />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            <div className='modal-footer d-flex justify-content-end'>
              <button onClick={() => setShowModal(false)} className='btn btn-light'>Fechar</button>
            </div>
          </div>
        </div>
      </div>

      {graficoAberto && (
        <div className='modal fade show d-block' tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className='modal-dialog modal-dialog-centered modal-lg'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title'>{graficoAberto.titulo}</h5>
                <button type='button' className='btn-close' onClick={() => setGraficoAberto(null)} />
              </div>
              <div className='modal-body'>
                {(() => {
                  const dadosGrafico = getDadosGraficoPergunta(graficoAberto.perguntaId)

                  const series = dadosGrafico.labels.map((label, idx) => ({
                    name: label,
                    data: [dadosGrafico.porcentagens[idx]],
                  }))

                  return (
                    <Chart
                      options={{
                        chart: {
                          type: 'bar',
                          stacked: true,
                          toolbar: { show: false },
                        },
                        plotOptions: {
                          bar: {
                            horizontal: true,
                            barHeight: '40%',
                          },
                        },
                        xaxis: {
                          categories: [''],
                          max: 100,
                          labels: {
                            formatter: val => `${val}%`,
                          },
                        },
                        dataLabels: {
                          enabled: true,
                          style: {
                            fontSize: '14px',
                            colors: ['#1E1E1E'],
                          },
                          formatter: function (val: number) {
                            return `${val.toFixed(2)}%`
                          },
                        },
                        tooltip: {
                          y: {
                            formatter: function (val: number) {
                              return `${val.toFixed(2)}%`
                            },
                          },
                        },
                        fill: { opacity: 1 },
                        legend: { show: false },
                        colors: ['#F1416C', '#FFC700', '#50CD89'],
                      }}
                      series={series}
                      type='bar'
                      height='150px'
                    />
                  )
                })()}

                {(() => {
                  const perguntaAtual = dispersao?.Perguntas.find(q => q.Id === graficoAberto.perguntaId)
                  const totalRes = perguntaAtual?.IdsParticipantes.filter(id =>
                    dadosGraficosPesquisa?.Participantes.some(pt => pt.Id === id)
                  ).length ?? 0

                  const dadosGrafico = getDadosGraficoPergunta(graficoAberto.perguntaId)
                  const indexTipo = dadosGrafico.labels.findIndex(lbl => lbl === dispersao?.Nome)
                  const percentualGrafico = dadosGrafico.porcentagens[indexTipo] ?? 0

                  return (
                    <div className='accordion' id='acc-parts'>
                      <div className='accordion-item'>
                        <h2 className='accordion-header' id='head-p'>
                          <button
                            className='accordion-button collapsed'
                            type='button'
                            data-bs-toggle='collapse'
                            data-bs-target='#coll-p'
                            aria-expanded='false'
                            style={{ backgroundColor: fillColor }}
                          >
                            <div className='d-flex w-100 align-items-center justify-content-between'>
                              <span>Participantes</span>
                              <div className='d-flex align-items-center'>
                                <span
                                  className='badge-value'
                                  style={{
                                    backgroundColor: 'rgba(255,255,255,0.3)',
                                    padding: '0.25rem 0.75rem',
                                    borderRadius: '0.25rem',
                                    fontWeight: 600,
                                    minWidth: '3rem',
                                    textAlign: 'center',
                                  }}
                                >
                                  {totalRes}
                                </span>
                                <span
                                  className='badge-value ms-2'
                                  style={{
                                    backgroundColor: 'rgba(255,255,255,0.3)',
                                    padding: '0.25rem 0.75rem',
                                    borderRadius: '0.25rem',
                                    fontWeight: 600,
                                    minWidth: '4rem',
                                    textAlign: 'center',
                                  }}
                                >
                                  {percentualGrafico.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                  %
                                </span>
                              </div>
                            </div>
                          </button>
                        </h2>
                        <div className='accordion-collapse collapse' id='coll-p' data-bs-parent='#acc-parts'>
                          <div className='accordion-body'>
                            {perguntaAtual?.IdsParticipantes.map(id => {
                              const part = dadosGraficosPesquisa?.Participantes.find(p => p.Id === id)
                              return (
                                <div key={id} className='menu-content d-flex align-items-center px-3 py-2 gap-3'>
                                  <div className='symbol symbol-75px'>
                                    <img alt='Foto' src={part?.FotoDataUrl ?? toAbsoluteUrl('/media/avatars/blank.png')} />
                                  </div>
                                  <div className='d-flex flex-column'>
                                    <span className='fw-bolder fs-5' style={{ color: fillColor }}>{part?.Nome}</span>
                                    <span className='fw-bold text-muted fs-7'>{part?.Email}</span>
                                    <span className='fw-bold text-muted fs-7'>{part?.NomeCargo}</span>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })()}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export { ModalGraficoDispersao }
